import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class LoadingErrorsService {
	statusCode: string;
	statusText: string;
	description: string;

	constructor(private router: Router) {}

	// Store error information, previous page URL, and navigate to error page
	openErrorPage(statusCode: string, statusText: string, description: string) {
		this.statusCode = statusCode;
		this.statusText = statusText === 'OK' ? $localize`Error` : statusText;
		this.description = description;
		localStorage.setItem('returnTo', this.router.url === '/error' ? '' : this.router.url);
		this.router.navigate(['/error'], { queryParamsHandling: 'preserve' });
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
